import React, { useState } from "react";
import Pagination from "./Pagination";
import { Link } from "react-router-dom";

const AllocateNewDriverTable = ({
  headers,
  data = [],
  pageSize = 10,
  eventHandler,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  // Ensure data is an array before using it
  const currentTableData = data?.slice(startIndex, endIndex);

  // Adjust class names for headers
  const getClassNamesForHeader = (header) => {
    const headerClassMap = {
      "Sr No.": `${data.length > 0 ? "w-[5%]" : "w-full"}`,
      "Driver ID": `${data.length > 0 ? "w-[20%]" : "w-full"}`,
      "Driver's name": `${data.length > 0 ? "w-[10%]" : "w-full"}`,
      "Driver's phone no.": `${data.length > 0 ? "w-[13%]" : "w-full"}`,
      "Deliveries done": `${data.length > 0 ? "w-[10%]" : "w-full"}`,
    };

    return headerClassMap[header] || (data.length <= 0 ? "w-full" : "w-[10%]"); // Default width if no match
  };

  return (
    <>
      <div className="border-2 border-t-4 border-quaternary bg-[#F7F9F8] text-[#413F3F] overflow-x-scroll relative rounded-xl h-full overflow-x-auto px-3">
        <div className="flex flex-col">
          <div className="w-full overflow-x-auto rounded-t-lg">
            <table
              className={`${
                data.length > 0 ? "w-full" : "w-full"
              } table-fixed divide-y divide-gray-200 dark:divide-gray-700`}
            >
              <thead>
                <tr>
                  {headers.map((header, index) => (
                    <th
                      key={index}
                      className={`text-start text-[14px] font-bold leading-5 px-4 py-1 h-12 whitespace-nowrap ${getClassNamesForHeader(
                        header
                      )}`}
                    >
                      {header}
                    </th>
                  ))}
                  <th className="w-[20%]"></th>
                </tr>
              </thead>
              {data.length > 0 ? (
                <tbody className="divide-y-[1px] divide-[#8D8D8D]">
                  {currentTableData.map((item, index) => (
                    <tr
                      key={index}
                      className={`w-full ${
                        index % 2 === 0 ? "bg-gray-100" : ""
                      }`}
                    >
                      <td className="px-4 py-4 break-words text-sm font-medium">
                        {startIndex + index + 1}
                      </td>
                      <td className="px-4 py-4 break-all text-sm font-medium">
                        {item?._id}
                      </td>
                      <td className="px-4 py-4 break-words text-sm font-medium">
                        {item?.name}
                      </td>
                      <td className="px-4 py-4 break-words text-sm font-medium">
                        {item?.phone || "N/A"}
                      </td>
                      <td className="px-4 py-4 break-words text-sm font-medium">
                        {item?.current_deliveries_count || "N/A"}
                      </td>
                      <td className="px-4 py-4 break-words text-sm font-medium flex items-center gap-3">
                        <Link
                          to={`/drivers/${item?._id}`}
                          className={`border border-quaternary text-quaternary font-semibold w-32 block py-1.5 rounded-md whitespace-nowrap text-center`}
                        >
                          View details
                        </Link>
                        <button
                          onClick={() => eventHandler(item?._id)}
                          className={`bg-quaternary text-white font-semibold w-32 block py-1.5 rounded-md shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px] whitespace-nowrap text-center`}
                        >
                          Assign order
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr className="">
                    <td
                      colSpan={headers.length}
                      className="px-3 py-4 italic text-sm font-medium text-center"
                    >
                      They’re likely negotiating with the weather gods for the
                      perfect cloud-to-sun ratio.
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
      <div className="flex justify-center">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={data.length}
          pageSize={pageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
};
export default AllocateNewDriverTable;
